import React from 'react';
import { Stack } from '@mui/material';

// Components
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import TerminalTable from 'src/features/PortDetail/Terminals/TerminalTable';
import TurnaroundChart from 'src/features/PortDetail/Terminals/TurnaroundChart';

// Utilities
import { ITradePortDetailInfo } from 'src/utils/typings/response';

interface IProps {
  portDetail: ITradePortDetailInfo | null;
}

const TerminalTab = ({ portDetail }: IProps) => {
  return (
    <React.Fragment>
      <Stack direction="column" spacing={3}>
        <TerminalTable listTerminal={getArrayDefault(portDetail?.terminals)} />
        <TurnaroundChart
          locode={portDetail?.meta?.locode || ''}
          countryVerbose={portDetail?.meta?.country_verbose || ''}
        />
      </Stack>
    </React.Fragment>
  );
};

export default TerminalTab;
